import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface NotificationData {
  id: number;
  message: string;
  viewed: boolean;
  category: string;
}

export interface PaginationInfo {
  pageSize: number;
  pageNumber: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent {
  @Input() notifications: NotificationData[] = [];
  @Input() pagination: PaginationInfo = {
    pageSize: 5,
    pageNumber: 0,
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: false
  };
  @Input() isLoading: boolean = false;
  @Input() showPagination: boolean = true;

  @Output() remove = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();

  onRemoveItem(id: number): void {
    this.remove.emit(id);
  }

  onNextPage(): void {
    if (!this.pagination.last) {
      this.pageChange.emit(this.pagination.pageNumber + 1);
    }
  }

  onPreviousPage(): void {
    if (!this.pagination.first) {
      this.pageChange.emit(this.pagination.pageNumber - 1);
    }
  }

  get isEmpty(): boolean {
    return this.notifications.length === 0 && !this.isLoading;
  }

  get itemsText(): string {
    const start = this.pagination.pageNumber * this.pagination.pageSize + 1;
    const end = Math.min(start + this.notifications.length - 1, this.pagination.totalElements);
    return `${start} - ${end} of ${this.pagination.totalElements}`;
  }

  trackByNotificationId(_index: number, notification: NotificationData): number {
    return notification.id;
  }
}
